import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import get from 'lodash/get';
import lowerCase from 'lodash/lowerCase';
import Table from '../../components/Table';
import Toast from '../../components/Toast';
import HEAccountUsersTableRow from './he-account-users-table-row';
import './styles.css';

const messages = defineMessages({
  status: {
    id: 'he-account.users-table.status',
    defaultMessage: 'Status',
  },
  community: {
    id: 'he-account.users-table.community',
    defaultMessage: 'Community',
  },
  role: {
    id: 'he-account.users-table.role',
    defaultMessage: 'Role',
  },
  firstName: {
    id: 'he-account.users-table.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'he-account.users-table.lastName',
    defaultMessage: 'Last Name',
  },
  login: {
    id: 'he-account.users-table.login',
    defaultMessage: 'Login',
  },
  actions: {
    id: 'he-account.users-table.actions',
    defaultMessage: 'Actions',
  },
});

class HEAccountUsersTable extends React.PureComponent {
  static propTypes = {
    node: PropTypes.object,
    showDisabledUsers: PropTypes.bool,
    handleViewCCProfile: PropTypes.func,
    isViewEditCCProfileButtonEnabled: PropTypes.bool,
  };

  state = {
    success: null,
  };

  _handleSuccess = (success) => {
    this.setState({ success });
  };

  render() {
    const { node, showDisabledUsers, handleViewCCProfile, isViewEditCCProfileButtonEnabled } = this.props;
    let { userList } = node;
    const { success } = this.state;
    userList = userList.filter((user) => user.active !== showDisabledUsers);

    if (userList.length > 0) {
      userList = [...userList];
      const primaryUserId = get(node, 'primaryUser.id');
      const primaryUser = userList.find((user) => user.id === primaryUserId);
      const userListNoPrimary = userList.filter((user) => user.id !== primaryUserId);
      userList = userListNoPrimary.sort((a, b) =>
        (lowerCase(a.lastName) < lowerCase(b.lastName) ? -1 : 1));
      if (primaryUser) userList.unshift(primaryUser);
    }

    return (
      <Table>
        <caption styleName="caption">
          <FormattedMessage
            id="he-account.users-table.caption"
            defaultMessage="{name}'s User List"
            values={{
              name: node.name,
            }}
          />
        </caption>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <FormattedMessage {...messages.status} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage {...messages.firstName} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage {...messages.lastName} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage {...messages.role} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage {...messages.community} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage {...messages.login} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage {...messages.actions} />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {success && <Toast active {...success} />}
          {userList.map((user) => (
            <HEAccountUsersTableRow
              user={user}
              key={user.id}
              heAccount={node}
              onSuccess={this._handleSuccess}
              handleViewCCProfile={handleViewCCProfile}
              isViewEditCCProfileButtonEnabled={isViewEditCCProfileButtonEnabled}
            />
          ))}
        </Table.Body>
      </Table>
    );
  }
}

export default HEAccountUsersTable;
